import React from 'react';

import RefreshIcon from '@material-ui/icons/Refresh';
import styled from 'styled-components';
import { NewStyledIconButton, StyledTooltip } from 'styles/common';

import theme from 'constants/theme';

export default function RefreshButton({ onClick, isDisabled }) {
  return (
    <Wrapper>
      <StyledTooltip title="Refresh Tasks">
        <NewStyledIconButton
          leftGutter={0}
          size="header"
          onClick={onClick}
          disabled={isDisabled}
          color={theme.palette.text.primary}
          // style={{ marginLeft: 0 }}
        >
          <RefreshIcon />
        </NewStyledIconButton>
      </StyledTooltip>
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  font-size: 1em;
  padding: 9px;
  margin-left: 10px;
`;
